const APP_PLATFORM = {
    SFAVICTORY: "sfa_victory",
    SFAVICTORYREGULER: "tp_sfa_victory",
}

const TYPE_SALES = {
    REGULER: 'sales_reguler',
    WSMM: 'sales_wsmm',
    SALES_ORDER: 'sales_order',
    CVS: 'sales_cvs',
}

const STATUS_ORDER = new Map([
    [0, 'ANTRIAN'],
    [1, 'DIPROSES'],
    [2, 'DITOLAK GROSIR'],
    [3, 'DIKIRIM'],
    [4, 'DITERIMA'],
    [5, 'DITOLAK TOKO'],
])

const STATUS_ORDER_COLOR = new Map([
    // { label: "Waiting Confirmation", color: "#dec807" },
    // { label: "Picking", color: "#FF8C00" },
    // { label: "Shipping", color: "#007BFF" },
    // { label: "Delivered", color: "#00AA13" },
    // { label: "Done", color: "#00AA13" },
    // { label: "Cancelled", color: "#DC3545" },
    [0, "#dec807"],
    [1, "#FF8C00"],
    [2, '#DC3545'],
    [3, '#007BFF'],
    [4, '#00AA13'],
    [5, '#DC3545'],
]);

const FEATURE_VICTORY = {
    ABSEN_MASUK_GROSIR: 'Absen Masuk Grosir',
    ABSEN_PULANG_GROSIR: 'Absen Pulang Grosir',
    ABSEN_MASUK_KUNJUNGAN_TOKO: 'Absen Masuk Kunjungan Toko',
    ABSEN_PULANG_KUNJUNGAN_TOKO: 'Absen Pulang Kunjungan Toko',
    ORDER_SFA: 'Buat Order via SFA',
    KUNJUNGAN_NON_CB: 'Kunjungan Non CB',
    PENGAJUAN_PESERTA_DISPLAY: 'Pengajuan Peserta Display Baru',
    MISI_SURVEY_SALESMAN: 'Misi Survey Salesman',
    PENGAJUAN_ADJUSTMENT_BN_TOKO: 'Penyesuaian Plafon Bayar Nanti Toko',
    PENGAJUAN_NEW_OPEN_OUTLET: 'Pengajuan New Open Outlet (NOO)'
}

const FEATURE_POSSIBILITY_FAKE_GPS = new Map([
    [FEATURE_VICTORY.ABSEN_MASUK_GROSIR, "User Login / Sales Melakukan Absen Masuk Di Grosir"],
    [FEATURE_VICTORY.ABSEN_PULANG_GROSIR, "User Login / Sales Melakukan Absen Pulang Di Grosir"],
    [FEATURE_VICTORY.ABSEN_MASUK_KUNJUNGAN_TOKO, "User Login / Sales Melakukan Absen Masuk Kunjungan Toko"],
    [FEATURE_VICTORY.ABSEN_PULANG_KUNJUNGAN_TOKO, "User Login / Sales Melakukan Absen Pulang Kunjungan Toko"],
    [FEATURE_VICTORY.ORDER_SFA, "User Login / Sales Membuat Order via Sales Force Automation"],
    [FEATURE_VICTORY.KUNJUNGAN_NON_CB, "User Login / Sales Melakukan Kunjungan Toko Non CB"],
    [FEATURE_VICTORY.PENGAJUAN_PESERTA_DISPLAY, "User Login / Sales Mengajukan Peserta Display Baru"],
    [FEATURE_VICTORY.MISI_SURVEY_SALESMAN, "User Login / Sales Melakukan Misi Survey ke Toko"],
    [FEATURE_VICTORY.PENGAJUAN_ADJUSTMENT_BN_TOKO, "User Login / Sales Melakukan Penyesuaian Plafon Toko"],
    [FEATURE_VICTORY.PENGAJUAN_NEW_OPEN_OUTLET, "User Login / Sales Melakukan Pengajuan New Open Outlet (NOO)"],
])

const COMPONENT_INCENTIVE_SALESMAN = {
    KUNJUNGAN_CALLPLAN: 'kunjungan-callplan',
    KUNJUNGAN_NON_CALLPLAN: 'kunjungan-diluar-callplan',
    EC_BELANJA_DENGAN_FEE_APLIKASI: 'ec-belanja-dengan-fee-aplikasi',
    OA_BERSYARAT: 'oa-bersyarat',
}

const COMPONENT_INCENTIVE_SALESMAN_TIPE = new Map([
    [COMPONENT_INCENTIVE_SALESMAN.KUNJUNGAN_CALLPLAN, "Kunjungan"],
    [COMPONENT_INCENTIVE_SALESMAN.KUNJUNGAN_NON_CALLPLAN, "Kunjungan"],
    [COMPONENT_INCENTIVE_SALESMAN.EC_BELANJA_DENGAN_FEE_APLIKASI, "Transaksi"],
    [COMPONENT_INCENTIVE_SALESMAN.OA_BERSYARAT, "Toko"],
])

const COMPONENT_INCENTIVE_SALESMAN_ICON = new Map([
    [COMPONENT_INCENTIVE_SALESMAN.KUNJUNGAN_CALLPLAN, require('../images/kunjungan-toko.png')],
    [COMPONENT_INCENTIVE_SALESMAN.KUNJUNGAN_NON_CALLPLAN, require('../images/kunjungan-toko.png')],
    [COMPONENT_INCENTIVE_SALESMAN.EC_BELANJA_DENGAN_FEE_APLIKASI, require('../images/ec-belanja.png')],
    [COMPONENT_INCENTIVE_SALESMAN.OA_BERSYARAT, require('../images/oa-bersyarat.png')],
])

const COMPONENT_INCENTIVE_SALESMAN_STYLE_ICON = new Map([
    [COMPONENT_INCENTIVE_SALESMAN.KUNJUNGAN_CALLPLAN, { width: 50 }],
    [COMPONENT_INCENTIVE_SALESMAN.KUNJUNGAN_NON_CALLPLAN, { width: 50 }],
    [COMPONENT_INCENTIVE_SALESMAN.EC_BELANJA_DENGAN_FEE_APLIKASI, { height: 50 }],
    [COMPONENT_INCENTIVE_SALESMAN.OA_BERSYARAT, { height: 50 }],
])

export { APP_PLATFORM, STATUS_ORDER, STATUS_ORDER_COLOR, FEATURE_VICTORY, FEATURE_POSSIBILITY_FAKE_GPS, TYPE_SALES, COMPONENT_INCENTIVE_SALESMAN, COMPONENT_INCENTIVE_SALESMAN_TIPE, COMPONENT_INCENTIVE_SALESMAN_ICON, COMPONENT_INCENTIVE_SALESMAN_STYLE_ICON };
